import { CartItem } from '@/models/cart/cart-item'
import { containsFreeShippingItem } from '@/models/shipping-fee/free-shipping-item'

/**
 * 送料無料フラグの商品によって、注文の送料が無料になると確定しているか。
 *
 * 予約商品を含むときは確定しない。予約商品は別の注文に分かれ、送料無料フラグは同じ注文の中でしか効かないため、送料のかかる注文が残りうる。
 * 合計金額による送料無料は扱わない。判定の基準額からクーポン・ポイントを差し引くため、それらを適用する前のカートでは確定できない。
 *
 * @param purchasableItems 購入可能な商品のみを与えること。購入不可の商品が含まれていた場合の挙動は保証しない
 */
export function isConfirmedFreeShippingByItem(purchasableItems: ReadonlyArray<CartItem>): boolean {
  if (purchasableItems.some(item => item.isPreSales)) {
    return false
  }

  return containsFreeShippingItem(purchasableItems)
}
